// extracted by mini-css-extract-plugin
module.exports = {"sFavorite":"sFavorite_sFavorite__U082Q"};